import { IUiIcon } from '../../../types/ui'

export const IconDollar = (
	{
		size = 24,
		imgSize= 24,
		fill = "none",
		stroke = "currentColor"
	}: IUiIcon
) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg"
		     width={`${size}px`}
		     height={`${size}px`}
		     viewBox={`0 0 ${imgSize} ${imgSize}`}
		     fill={fill}
		     stroke={stroke}
		     strokeWidth="2"
		     strokeLinecap="round"
		     strokeLinejoin="round"
		     className="feather feather-dollar-sign"
		>
			<line x1="12" y1="1" x2="12" y2="23"></line>
			<path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
		</svg>
	)
}